import { Link, useNavigate } from 'react-router-dom';
import PlanSelectionStep from '@/pages/auth/components/PlanSelectionStep';
import ScrollReveal from '@/components/common/ScrollReveal';
import SectionTitle from './SectionTitle';

export default function TrustPricing() {
  const navigate = useNavigate();

  const handleSelectPlan = (planId: string) => {
    navigate(`/login?plan=${encodeURIComponent(planId)}`);
  };

  return (
    <section id="pricing" className="w-full bg-gradient-to-b from-white via-[#f7f8fc] to-white pb-16 md:pb-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          title="Choose the plan that fits your program"
          subtitle="Start free. No per-redemption fees. Upgrade only as your member base grows."
        />
        {/* Shared with the sign-up flow (pages/auth). */}
        <ScrollReveal animation="fade-up" delay={120} className="w-full">
          <PlanSelectionStep lang="en" hideHeaderTitle={true} onSelectPlan={handleSelectPlan} />
        </ScrollReveal>
        <div className="mt-8 flex justify-center">
          <Link to="/pricing" className="inline-flex items-center gap-1 text-sm font-semibold text-[#2f51d6] hover:underline">
            Compare all plans and usage <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
